import { render } from "./numberPlusMinus.vue?vue&type=template&id=e22e5118&ts=true"
import script from "./numberPlusMinus.vue?vue&type=script&lang=ts"
export * from "./numberPlusMinus.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__